import { useCallback } from 'react';

export const useFocusElement = () => {
  const focusElement = useCallback((selector: string) => {
    const element = document.querySelector(selector) as HTMLInputElement;
    element?.focus();
  }, []);

  return { focusElement };
};